import React, {Component} from 'react';
import Modal from 'react-modal';
import {LevelTrackerComponent} from "../StudentsComponent/Common";
import ProgressBox from "./ProgressBox";

Modal.setAppElement('body');

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30%'
    }
};

class ProgressModal extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <Modal isOpen={this.props.isOpen} style={customStyle}>
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="clearfix"></div>
                        <ProgressBox
                            level={this.props.level || 1}
                            step={this.props.step || 1}
                            steps={this.props.steps || 6}
                        />
                    </div>
                    <div className="modal-footer">
                        <a onClick={this.props.closeModal} className="handBtn"><span>Go</span></a>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ProgressModal;



// WEBPACK FOOTER //
// ./src/ProgressModalComponent/ProgressModal.js